import { Pipe, PipeTransform } from '@angular/core';
import { SelectionOption } from '@core/models';

@Pipe({
    name: 'findfromid',
    standalone: false
})
export class FindfromidPipe implements PipeTransform {

  transform(id: number | boolean | string, selectionOptions: SelectionOption[], sysText: any = null): any {
    if (id == null)
      return null;
    
    var selectionOption: SelectionOption = null;

    if (sysText != null) {
      selectionOption = selectionOptions?.find(so => id == so.id + "." + so.relevantContextId + "." + so.emailAddressTypeId);
      
      if (selectionOption != null)
        return {
          ...selectionOption,
          relevantContextName: sysText["relevantContext" + selectionOption.relevantContextId],
          emailAddressTypeName: sysText["emailAddressType" + selectionOption.emailAddressTypeId],
        };
    }

    selectionOption = selectionOptions?.find(s => s.id === id);

    if (selectionOption == null)
      return id;

    return selectionOption.description;
  }
}
